import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Bushireinpatasdaund() {



const cardData =
  {
    keyword: 'Bus Hire in Patas Daund',
    heading: 'Sanavi Travels: Bus Hire in Patas Daund',
    headingDescription: 'Sanavi Travels offers professional and dependable Bus Hire in Patas Daund, providing safe, spacious, and comfortable transportation for families, large groups, corporate travel, school trips, weddings, picnics, and outstation journeys. Patas, located near Daund, is a key travel point for agricultural, industrial, and residential movement, making organized bus transport essential for group travel. Our fleet includes well-maintained AC buses, Non-AC buses, mini buses, luxury coaches, and large seating capacity buses designed to handle both short and long-distance travel with ease. Each bus offers comfortable seating, adequate legroom, proper ventilation, and sufficient luggage space to ensure a relaxed journey for passengers of all age groups. With experienced and route-familiar drivers, flexible rental options such as one-way, round-trip, and multi-day packages, transparent pricing without hidden charges, and 24/7 customer assistance, bus hire in Patas Daund becomes a convenient and stress-free solution. Choose Sanavi Travels for reliable bus hire services in Patas Daund, ensuring punctuality, safety, comfort, and a smooth group travel experience every time.',

    top: 'Top Places to Visit Near Patas Daund with Sanavi Travels',


"topPlaces": [
  {
    "title": "Patas Town",
    "description": "Patas is a prominent town near Daund known for its agricultural markets, railway connectivity, and growing residential areas. Group travel by bus is common here for social events, business travel, and family functions due to convenient road access."
  },
  {
    "title": "Daund Railway Junction",
    "description": "Daund Railway Junction is one of the busiest rail hubs in the region, attracting travelers from surrounding towns. Bus hire services from Patas to Daund are ideal for group transfers, pilgrimages, and coordinated travel plans."
  },
  {
    "title": "Bhigwan Backwaters",
    "description": "Bhigwan Backwaters, located close to Patas and Daund, is a popular destination for bird watching, nature photography, and picnic trips. Hiring a bus ensures comfortable and organized travel for families, schools, and tourist groups."
  },
  {
    "title": "Jejuri Khandoba Temple",
    "description": "Jejuri is a major pilgrimage site frequently visited by devotees from Patas and Daund. Bus hire makes religious group travel easy, safe, and well-coordinated, especially during festivals and special occasions."
  },
  {
    "title": "MIDC and Industrial Zones",
    "description": "Industrial and MIDC areas near Patas and Daund generate regular corporate and employee movement. Buses are commonly hired for staff transport, factory visits, and corporate travel needs."
  },
  {
    "title": "Pune City Tourist Attractions",
    "description": "Patas offers good road connectivity to Pune city, enabling group sightseeing tours to locations such as temples, historical forts, and shopping destinations using hired buses."
  },
  {
    "title": "Agricultural Villages",
    "description": "Surrounding villages around Patas are known for farming and rural lifestyle. Educational tours and rural exposure trips often rely on bus hire for safe and organized travel."
  },
  {
    "title": "Wedding Lawns and Banquet Halls",
    "description": "Several wedding venues and banquet halls around Patas and Daund require bus rentals for transporting guests smoothly between locations."
  },
  {
    "title": "Local Picnic Spots",
    "description": "Small picnic locations and open spaces near Patas are ideal for family outings, school picnics, and social group trips, where bus hire offers convenience and affordability."
  },
  {
    "title": "Outstation Travel Routes",
    "description": "Patas is well connected to outstation destinations like Shirdi, Solapur, Nashik, Kolhapur, Pune, and Mumbai, making bus hire suitable for long-distance group journeys."
  }
]
,



"services": [
{
"name": "Bus Hire in Patas Daund",
"description": "Bus Hire in Patas Daund provides reliable and comfortable buses for families, groups, schools, corporate clients, and social gatherings. These buses are ideal for weddings, picnics, school trips, religious tours, and long-distance travel with professional drivers ensuring safety and punctuality."
},
{
"name": "Bus on Rent Patas Daund",
"description": "Bus on Rent Patas Daund offers flexible rental options for short-term and long-term travel needs, including local transport, outstation trips, and event-based group travel."
},
{
"name": "AC Bus Hire Patas Daund",
"description": "AC Bus Hire Patas Daund ensures a cool and comfortable journey with fully air-conditioned interiors, cushioned seating, and smooth suspension for longer routes."
},
{
"name": "Non AC Bus Rental Patas",
"description": "Non AC Bus Rental Patas provides economical transportation for short-distance travel, rural routes, school trips, and budget-conscious group journeys."
},
{
"name": "Luxury Bus Hire Patas Daund",
"description": "Luxury Bus Hire Patas Daund delivers premium travel comfort with modern interiors, spacious seating, and enhanced amenities, ideal for weddings and corporate travel."
},
{
"name": "Mini Bus Hire Patas",
"description": "Mini Bus Hire Patas is suitable for smaller groups, family gatherings, local functions, and short-distance travel with cost-effective pricing."
},
{
"name": "32 Seater Bus Hire Patas",
"description": "32 Seater Bus Hire Patas is perfect for medium-sized groups such as school trips, office outings, and social events, offering adequate seating and luggage space."
},
{
"name": "35 Seater Bus Rental Patas Daund",
"description": "35 Seater Bus Rental Patas Daund supports larger groups with comfortable seating, smooth travel experience, and professional driver support."
},
{
"name": "Bus Hire Patas for Wedding",
"description": "Bus Hire Patas for Wedding ensures smooth and timely transportation of wedding guests, relatives, and family members between venues."
},
{
"name": "Bus Hire Patas for Corporate Travel",
"description": "Bus Hire Patas for Corporate Travel supports employee transport, meetings, industrial visits, conferences, and corporate events with disciplined service."
},
{
"name": "Bus Hire Patas for Picnic",
"description": "Bus Hire Patas for Picnic offers safe and convenient transportation for school picnics, family outings, and leisure trips."
},
{
"name": "Bus Hire Patas for School Trip",
"description": "Bus Hire Patas for School Trip provides safe buses with experienced drivers for educational tours, excursions, and student outings."
},
{
"name": "Bus Rental Patas Daund Outstation",
"description": "Bus Rental Patas Daund Outstation offers dependable long-distance group travel to major cities and pilgrimage destinations."
},
{
"name": "Bus Hire Patas with Driver",
"description": "Bus Hire Patas with Driver offers chauffeur-driven buses where experienced drivers handle routes, traffic, and safety throughout the journey."
},
{
"name": "Cheap Bus Hire Patas Daund",
"description": "Cheap Bus Hire Patas Daund provides budget-friendly bus rental services for groups seeking economical yet reliable transportation."
}
],
"tableData": [
["Bus Hire in Patas Daund", "Bus on Rent Patas Daund"],
["AC Bus Hire Patas Daund", "Non AC Bus Rental Patas"],
["Luxury Bus Hire Patas Daund", "Mini Bus Hire Patas"],
["32 Seater Bus Hire Patas", "35 Seater Bus Rental Patas Daund"],
["Wedding Bus Patas", "Corporate Bus Patas"],
["Picnic Bus Patas", "School Trip Bus Patas"],
["Bus Hire Patas with Driver", "Cheap Bus Hire Patas Daund"],
["Outstation Bus Patas Daund", "—"]
]
,


"whychoose": [
  {
    "WhyChooseheading": "Bus Hire in Patas Daund with Sanavi Travels",
    "WhyChoosedescription": "Sanavi Travels is a trusted provider of bus hire services in Patas Daund, offering reliable transportation for family trips, corporate travel, school excursions, weddings, and social events."
  },
  {
    "WhyChooseheading": "Well-Maintained and Spacious Buses",
    "WhyChoosedescription": "All buses are clean, spacious, and regularly serviced to ensure a smooth, safe, and comfortable travel experience for all passengers."
  },
  {
    "WhyChooseheading": "Experienced and Route-Familiar Drivers",
    "WhyChoosedescription": "Our professional drivers are well-versed with Patas, Daund, and surrounding routes, ensuring timely pickups and safe journeys."
  },
  {
    "WhyChooseheading": "Transparent and Honest Pricing",
    "WhyChoosedescription": "We follow clear pricing policies with no hidden charges, including fuel, tolls, and driver allowances."
  },
  {
    "WhyChooseheading": "24/7 Booking and Customer Support",
    "WhyChoosedescription": "Our support team is available round the clock to assist with bookings, travel planning, and on-trip coordination."
  },
  {
    "WhyChooseheading": "Flexible Rental Plans",
    "WhyChoosedescription": "We offer hourly, full-day, multi-day, and customized bus hire packages to suit different group travel needs."
  },
  {
    "WhyChooseheading": "Safe and Sanitized Vehicles",
    "WhyChoosedescription": "Every bus is thoroughly cleaned and sanitized before each journey to ensure a hygienic travel environment."
  },
  {
    "WhyChooseheading": "Reliable and Punctual Service",
    "WhyChoosedescription": "We ensure on-time service and disciplined operations, making Sanavi Travels a dependable choice for bus hire in Patas Daund."
  }
]

}

const faqData = [
  {
    question: 'Does Sanavi Travels provide bus hire services in Patas Daund?',
    answer: 'Yes, Sanavi Travels offers professional bus hire services in Patas Daund for all types of group travel.'
  },
  {
    question: 'How can I book a bus in Patas Daund?',
    answer: 'You can book a bus through our website or by contacting our 24x7 customer support team.'
  },
  {
    question: 'What types of buses are available in Patas Daund?',
    answer: 'We provide mini buses, 32-seater buses, 35-seater buses, luxury buses, AC buses, and Non-AC buses.'
  },
  {
    question: 'Are the drivers experienced with Patas and Daund routes?',
    answer: 'Yes, our drivers are licensed, professional, and familiar with Patas and Daund routes.'
  },
  {
    question: 'Is bus hire available for school trips?',
    answer: 'Yes, we offer safe and reliable buses for school trips and educational tours.'
  },
  {
    question: 'Are buses sanitized before every trip?',
    answer: 'Yes, all buses are cleaned and sanitized before each journey.'
  },
  {
    question: 'What payment options are available?',
    answer: 'We accept UPI, debit cards, credit cards, bank transfers, and corporate payments.'
  },
  {
    question: 'Is customer support available during the journey?',
    answer: 'Yes, our support team is available throughout the journey.'
  }
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Sunil Pawar',
    feedback: 'We hired a bus from Patas to Bhigwan for a picnic. The bus was clean and the service was very punctual.',
    rating: 5
  },
  {
    id: 2,
    name: 'Ms. Kavita Jadhav',
    feedback: 'Sanavi Travels arranged a bus for our school trip from Patas. Excellent coordination and safe journey.',
    rating: 5
  }
];










  const Images = [
    { place: "/images/keyword/1.jpg", text: "Tempo Traveller On Rent in Pune", link: "tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/2.jpg", text: "Pune to Shirdi Tempo Traveller On Rent", link: "pune-to-shirdi-tempo-traveller-on-rent" },
    { place: "/images/keyword/3.jpg", text: "Pune to Mahabaleshwar Tempo Traveller on Rent", link: "pune-to-mahabaleshwar-tempo-traveller-on-rent" },
    { place: "/images/keyword/4.jpg", text: "Pune to Goa Tempo Traveller Hire", link: "pune-to-goa-tempo-traveller-hire" },
    { place: "/images/keyword/5.jpg", text: "Pune to Mumbai Tempo Traveller on Rent", link: "pune-to-mumbai-tempo-traveller-on-rent" },
    { place: "/images/keyword/6.jpg", text: "Pune to Konkan Darshan Tempo Traveller Hire", link: "pune-to-konkan-darshan-tempo-traveller-hire" },
    { place: "/images/keyword/7.jpg", text: "Pune to Nashik Tempo Traveller On Rent", link: "pune-to-nashik-tempo-traveller-on-rent" },
    { place: "/images/keyword/8.jpg", text: "Tempo Traveller On Rent for Pune Darshan", link: "tempo-traveller-on-rent-for-pune-darshan" },
    { place: "/images/keyword/9.jpg", text: "Mini Bus On Rent in Pune", link: "mini-bus-on-rent-in-pune" },
    { place: "/images/keyword/10.jpg", text: "13 Seater Tempo Traveller On Rent in Pune", link: "13-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/11.jpg", text: "17 Seater Tempo Traveller on Rent in Pune", link: "17-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/12.jpg", text: "20 Seater Luxury Bus On Rent Pune", link: "20-seater-luxury-bus-on-rent-pune" },
    { place: "/images/keyword/13.jpg", text: "26 Seater Tempo Traveller On Rent in Pune", link: "26-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/14.jpg", text: "32 Seater Luxury Bus On Rent in Pune", link: "32-seater-luxury-bus-on-rent-in-pune" },
    { place: "/images/keyword/15.jpg", text: "35 Seater Bus on Rent in Pune", link: "35-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/16.jpg", text: "45 Seater Bus On Rent in Pune", link: "45-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/17.jpg", text: "50 Seater Bus On Rent in Pune", link: "50-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/18.jpg", text: "Bus Hire for School Trips in Pune", link: "bus-hire-for-school-trips-in-pune" },
    { place: "/images/keyword/19.jpg", text: "Bus booking for Wedding in Pune", link: "bus-booking-for-wedding-in-pune" },
    { place: "/images/keyword/20.jpg", text: "Bus Booking for Marriage in Pune", link: "bus-booking-for-marriage-in-pune" },
    { place: "/images/keyword/21.jpg", text: "Bus Service for Corporate in Pune", link: "bus-service-for-corporate-in-pune" },
    { place: "/images/keyword/22.jpg", text: "Bus on Rent For Event in Pune", link: "bus-on-rent-for-event-in-pune" },
    { place: "/images/keyword/23.jpg", text: "Bus Hire for Outstation in Pune", link: "bus-hire-for-outstation-in-pune" },
    { place: "/images/keyword/24.jpg", text: "AC Bus On Rent in Pune", link: "ac-bus-on-rent-in-pune" },
    { place: "/images/keyword/25.jpg", text: "Pune Bus Hire Rental Service", link: "pune-bus-hire-rental-service" },
  ];










const jsonData = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Bus Hire in Patas Daund - Sanavi Travels",
  "description": "Sanavi Travels provides bus hire in Patas Daund for weddings, corporate travel, school trips, picnics, and outstation journeys. We offer AC and Non-AC buses, luxury buses, mini buses, 32 seater and 35 seater buses with experienced drivers at affordable prices.",
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.7",
    "ratingCount": "190"
  }
};






  return (
    <div>

<Helmet>
  <title>
    Call : +91 7387507373 | Bus Hire in Patas Daund | Sanavi Travels
  </title>

  <meta
    name="description"
    content="Book bus hire in Patas Daund with Sanavi Travels. AC & Non-AC buses, luxury and mini bus rental for weddings, corporate travel, school trips, picnics, and outstation travel with driver at best rates."
  />

  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>

      <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box text-white">
                <h1 className="text-anime-style-3 text-center text-white" data-cursor="-opaque">
                  <h3> {cardData.keyword}</h3>
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>





      <section>
        <div className="container-fluid" >
          <div className="row container-fluid p-0">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/213.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>



              <div className="shambhu-services">
                {cardData.services.map((service, index) => (
                  <div key={index} className="sh-service-card">

                    <div className="sh-service-left">
                      <div className="sh-service-icon">
                        🚖
                      </div>
                    </div>

                    <div className="sh-service-content">
                      <h4 className="sh-service-title">{service.name}</h4>
                      <p className="sh-service-desc">{service.description}</p>
                    </div>

                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Sanavi Travels </span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Sanavi Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+917387507373" className="pc-call">+91 7387507373</a>
                      <a href="tel:+919595532929" className="pc-call">+91 9595532929</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/917387507373"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+917387507373" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@sanavitravels.com" className="pc-email">
                      booking@sanavitravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Sanavi Travels</strong><br />
                      OFFICE NO.6, GROUND FLOOR GAT NO.1110,
                      SHREE GOPINATH MAHARAJ VYAPARI SHED SHIVAJI CHOWK, VARVAND TAL DAUND,
                      DIST PUNE – 412215
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Bushireinpatasdaund;